/** Hook de auth: restaura la sesión desde localStorage al montar y expone el resto del authStore (login, logout, tokens, sucursal activa). */
import { useEffect } from "react";
import { useAuthStore } from "@/stores/authStore";

export const useAuth = () => {
  const { restoreSession, ...store } = useAuthStore();

  useEffect(() => {
    restoreSession();
  }, []);

  return { ...store };
};
